import { createSelector } from "@ngrx/store";
import * as fromRoot from '../../../_store';
import { AdministratorModeStateModel } from "../actions/administrator-mode.actions";
import * as fromFeature from '../reducers';
import * as fromAdministratorMode from '../reducers/administrator-mode.reducer';


export const getAdministratorModeState = createSelector(
    fromFeature.core,
    (state: fromFeature.CoreState) => state ? state.administratorMode : null
);

export const getAdministratorModeEntities = createSelector(
    getAdministratorModeState,
    fromAdministratorMode.getEntities
);

export const getSelectedAdministratorModeStateModel = createSelector(
    getAdministratorModeEntities,
    fromRoot.getRouterState,
    (entities): AdministratorModeStateModel => {
        return entities && entities['global'];
    }
);

export const getSelectedMenuItems = createSelector(
    getAdministratorModeEntities,
    fromRoot.getRouterState,
    (entities): AdministratorModeStateModel => {
        return entities['global'] && entities['global'].menuItems;
    }
);

export const getSelectedIsAdmin = createSelector(
    getSelectedAdministratorModeStateModel,
    fromRoot.getRouterState,
    (entity: AdministratorModeStateModel): any => entity && entity.isAdmin
);
